import { createPortal } from "react-dom";
import AlertModal from "../AlertModal";

export default function ClearSmartAssistSessionModal({ onClose, onConfirm }) {
  return createPortal(
    <AlertModal
      title="Clear Smart Assist chat history?"
      message="This permanently deletes the saved Smart Assist chat history for this patient. This action cannot be undone."
      confirmLabel="Clear chat"
      cancelLabel="Cancel"
      showCancel
      onConfirm={onConfirm}
      onClose={onClose}
    />,
    document.body
  );
}
